module.exports = __webpack_public_path__ + "img/playbar_pause_grey.f982e260.svg";